import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Select } from 'components/form/private/controls/Select';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { AutocompleteSelect } from './private/controls/AutocompleteSelect';
import './FormSelect.scss';
/**
 * @component FormSelect
 * @since 1.0.0
 */
export function FormSelect(props) {
    let { name, size, style, picto, badge, label, infos, error, options, required, optional, disabled, placeholder, defaultValue, tooltip, prefix, skipSort, suffix, search } = Object.assign({ style: 'normal', picto: 'chevron-down', placeholder: t('Choose') }, props);
    const form = useForm();
    const [ident] = useIdent('form-select');
    const [value, setValue] = useValue(name, props.value, defaultValue || '');
    const [focused, setFocused] = useState(false);
    // Order options by label
    if (!skipSort) {
        options.sort((a, b) => {
            return a.label.localeCompare(b.label);
        });
    }
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, [value]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-select', 'form-select--' + size, 'form-select--' + style, { 'form-select--is-required': required }, { 'form-select--is-optional': optional }, { 'form-select--is-disabled': disabled }, { 'form-select--is-focused': focused }, { 'form-select--has-label': label }, { 'form-select--has-value': value }, { 'form-select--has-picto': picto }, { 'form-select--has-badge': badge }, { 'form-select--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-select-field" },
            React.createElement("div", { className: "form-select-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-select-label", size: size, style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-select-infos", size: size, style: style, infos: infos }))),
            React.createElement("div", { className: "form-select-field-body" },
                prefix && React.createElement("div", { className: "form-select-prefix" }, prefix),
                !search ? (React.createElement(Select, { name: name, ident: ident, value: value, options: options, required: required, disabled: disabled, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, onChange: onChange })) : (React.createElement(AutocompleteSelect, { name: name, ident: ident, value: value, options: options, required: required, disabled: disabled, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, onChange: onChange })),
                picto && React.createElement(Icon, { className: "form-select-picto", value: picto }),
                badge && React.createElement(Text, { className: "form-select-badge", value: badge }),
                suffix && React.createElement("div", { className: "form-select-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
